import CryptoJS from 'crypto-js';

const SECRET = process.env.VUE_APP_HASH_KEY;

function set(key, value) {
    const encodedKey = CryptoJS.SHA256(key).toString();
    const rawValue = JSON.stringify(value);
    const encodedValue = SECRET
        ? CryptoJS.AES.encrypt(rawValue, SECRET).toString()
        : rawValue;

    localStorage.setItem(encodedKey, encodedValue);
}

function get(key) {
    const encodedKey = CryptoJS.SHA256(key).toString();
    const encodedValue = localStorage.getItem(encodedKey);

    if (!encodedValue) {
        return null;
    }

    try {
        if (!SECRET) {
            return encodedValue;
        }

        return CryptoJS.AES.decrypt(encodedValue, SECRET).toString(CryptoJS.enc.Utf8);
    } catch (error) {
        return null;
    }
}

function remove(key) {
    const encodedKey = CryptoJS.SHA256(key).toString();
    localStorage.removeItem(encodedKey);
}

function clear() {
    localStorage.clear();
}

export default {
    set,
    get,
    remove,
    clear
}
